import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Select } from '@ngxs/store';
import intersection from 'lodash-es/intersection';
import isEmpty from 'lodash-es/isEmpty';
import isEqual from 'lodash-es/isEqual';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificationsService } from '../../api/notifications.service';
import { User } from '../../model/user';
import { QueryContextState } from '../../state/action/state';
import { QueryContext } from '../../state/model/entity-geo-area';

@Directive({
  selector: '[appUserCannot]'
})
export class UserCannotDirective implements OnInit, OnDestroy {
  @Select(QueryContextState) state$: Observable<QueryContext>;
  private destroyed$ = new Subject<void>();
  private currentPermission: string[] = [];
  private expectedPermissions: string[] = [];
  private operator: operator = 'AND';
  private notificationMessage = '';

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {
  }

  @Input()
  set appUserCannot(permission: string[]) {
    this.expectedPermissions = permission;
    this.updateView();
  }

  @Input()
  set appUserCannotOperation(op: operator) {
    this.operator = op;
  }

  @Input()
  set appUserCannotNotificationMessage(notificationMessage: string) {
    this.notificationMessage = notificationMessage;
  }

  ngOnInit(): void {
    this.state$.pipe(takeUntil(this.destroyed$))
    .subscribe(state => this.updateView(state.user));
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
  }

  private updateView(user?: User) {
    const newPermission = user?.permissions ?? [];
    if (isEqual(this.currentPermission, newPermission)) {
      return;
    }
    this.currentPermission = newPermission;

    if (!this.checkPermission()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();

      if (this.notificationMessage) {
        NotificationsService.prototype.error('Not authorize', this.notificationMessage);
      }
    }
  }

  private checkPermission(): boolean {
    const permissionIntersection = intersection(this.expectedPermissions, this.currentPermission);
    return this.operator === 'OR' ? !isEmpty(permissionIntersection) : isEqual(permissionIntersection, this.expectedPermissions);
  }
}

type operator = 'OR' | 'AND';
